var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 149,
    viewBox: "0 0 161 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.2578 10.5786C78.2155 7.4406 82.7845 7.44061 84.7422 10.5786L141.84 102.104C143.917 105.434 141.523 109.75 137.598 109.75H23.4024C19.477 109.75 17.0825 105.434 19.1602 102.104L76.2578 10.5786Z",
    fill: "#FFEBB2",
    stroke: "#F2BB40",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4444 90C80.2222 90 79.1759 89.5648 78.3056 88.6944C77.4352 87.8241 77 86.7778 77 85.5556C77 84.3333 77.4352 83.287 78.3056 82.4167C79.1759 81.5463 80.2222 81.1111 81.4444 81.1111C82.6667 81.1111 83.713 81.5463 84.5833 82.4167C85.4537 83.287 85.8889 84.3333 85.8889 85.5556C85.8889 86.7778 85.4537 87.8241 84.5833 88.6944C83.713 89.5648 82.6667 90 81.4444 90ZM77 76.6667V50H85.8889V76.6667H77Z",
    fill: "#F2BB40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.b6367ce1e92fa721e5dc9dee80477be0.svg";
export { ForwardRef as ReactComponent };